<div class="user-details-popup">
  <div class="popup-description">
    <p class="description-text">
      Veuillez renseigner votre nom et prénom pour continuer à utiliser l'application.
      Ces informations sont nécessaires pour votre profil.
    </p>
  </div>

  <form [formGroup]="userDetailsForm" class="user-details-form">
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Prénom *</mat-label>
        <input
          matInput
          formControlName="firstName"
          placeholder="Saisissez votre prénom"
          autocomplete="given-name"
        >
        <mat-error *ngIf="firstNameControl?.invalid && firstNameControl?.touched">
          {{ firstNameErrorText }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nom *</mat-label>
        <input
          matInput
          formControlName="lastName"
          placeholder="Saisissez votre nom"
          autocomplete="family-name"
        >
        <mat-error *ngIf="lastNameControl?.invalid && lastNameControl?.touched">
          {{ lastNameErrorText }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-info">
      <mat-icon class="info-icon">info</mat-icon>
      <span class="info-text">
        Ces informations seront utilisées pour personnaliser votre expérience.
      </span>
    </div>
  </form>
</div>